import { gql } from "@apollo/client";
import { ProjectFieldsFragment } from "@govlaunch/project";

export default gql`
  mutation DeclineProjectVerification($projectId: ObjectId!, $governmentId: ObjectId!) {
    declineProjectVerification(projectId: $projectId, governmentId: $governmentId) {
      _id
      project {
        ...ProjectFields
      }
    }
  }

  ${ProjectFieldsFragment}
`;
